import { getWarehouseFacilityHeader } from '@/modules/warehouseModule/composables/useFacilityHeader'

const groupPrefix = createApiRoute(ApiModule.WAREHOUSE, ApiDataModel.INBOUND)

export const apiExpectedDeliveries = {
	fetchExpectedDeliveries: async (): Promise<IApiResponseModel<IWarehouseExpectedDeliveryModel[]>> => {
		const { data } = await apiCommon<IWarehouseExpectedDelivery[]>(`${groupPrefix}/expected-deliveries`, {
			method: 'GET',
			headers: getWarehouseFacilityHeader(),
		})

		return { data: data.map(d => WarehouseExpectedDelivery(d)) }
	},

	fetchExpectedDeliveryDetailed: async (
		id: string,
	): Promise<IApiResponseModel<IWarehouseExpectedDeliveryDetailedModel>> => {
		const { data } = await apiCommon<IWarehouseExpectedDeliveryDetailed>(
			`${groupPrefix}/expected-deliveries/${id}`,
			{
				method: 'GET',
				headers: getWarehouseFacilityHeader(),
			},
		)

		return { data: WarehouseExpectedDeliveryDetailed(data) }
	},

	startReceivingDelivery: async (
		expectedDeliveryId: string,
		body: IWarehouseStartReceivingDeliveryPayload,
	): Promise<void> => {
		await apiCommon(`${groupPrefix}/expected-deliveries/${expectedDeliveryId}/start-receiving`, {
			method: 'POST',
			body,
		})
	},

	skipExpectedDelivery: async (expectedDeliveryId: string): Promise<void> => {
		await apiCommon(`${groupPrefix}/expected-deliveries/${expectedDeliveryId}/skip`, {
			method: 'POST',
		})
	},

	cancelReceivingDelivery: async (deliveryReceiptId: string): Promise<void> => {
		await apiCommon(`${groupPrefix}/delivery-receipts/${deliveryReceiptId}/cancel`, {
			method: 'POST',
		})
	},

	finishReceivingDelivery: async (deliveryReceiptId: string): Promise<void> => {
		await apiCommon(`${groupPrefix}/delivery-receipts/${deliveryReceiptId}/finish`, {
			method: 'POST',
		})
	},

	receiveDeliveryItem: async (
		deliveryReceiptId: string,
		body: IWarehouseReceiveDeliveryItemPayload,
	): Promise<void> => {
		await apiCommon(`${groupPrefix}/delivery-receipts/${deliveryReceiptId}/receive-product`, {
			method: 'POST',
			body,
		})
	},

	acceptReceivingItem: async (
		deliveryReceiptId: string,
		body: IWarehouseAcceptReceivingItemPayload,
	): Promise<void> => {
		await apiCommon(`${groupPrefix}/delivery-receipts/${deliveryReceiptId}/accept-product`, {
			method: 'POST',
			body,
		})
	},

	revertReceivingItem: async (
		deliveryReceiptId: string,
		body: IWarehouseRevertReceivingItemPayload,
	): Promise<void> => {
		await apiCommon(`${groupPrefix}/delivery-receipts/${deliveryReceiptId}/revert-product`, {
			method: 'POST',
			body,
		})
	},

	reportDeliveryProductIssue: async (
		deliveryReceiptId: string,
		body: IWarehouseReportDeliveryProductIssuePayload,
	): Promise<void> => {
		await apiCommon(`${groupPrefix}/delivery-receipts/${deliveryReceiptId}/report-issue`, {
			method: 'POST',
			body,
		})
	},

	reportWholeDeliveryIssue: async (
		deliveryReceiptId: string,
		body: IWarehouseReportWholeDeliveryIssuePayload,
	): Promise<void> => {
		await apiCommon(`${groupPrefix}/delivery-receipts/${deliveryReceiptId}/report-whole-delivery`, {
			method: 'POST',
			body,
		})
	},

	importExpectedDeliveryDocument: async (deliveryReceiptId: string, documents: File[]) => {
		const formData = new FormData()
		documents.forEach(document => {
			formData.append('documents[]', document)
		})
		await apiCommon(
			`${groupPrefix}/delivery-receipts/${deliveryReceiptId}/documents`,
			{
				method: 'POST',
				body: formData,
			},
			'pl',
			true,
		)
	},
}
